import { Component, OnInit, OnDestroy } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { InstitutionsService } from '@app/services/institutions/institutions.service';
import { Router, NavigationStart } from '@angular/router';
import { SortService } from '@app/components/sorting/SortService';
import { Subscription } from 'rxjs';
import { ClaimsService } from '@app/services/claims/claims.service';
import { Enumroles } from '@app/models/enumroles.enum';

interface LodgeAndCamp {
  id: number;
  shortName: string;
  name: string;
}

@Component({
  selector: 'app-narvarohantering',
  templateUrl: './narvarohantering.component.html'
})
export class NarvarohanteringComponent implements OnInit, OnDestroy {
institutionform;
  
  institutionslist: LodgeAndCamp[] = [];
  institutionlist: LodgeAndCamp[] = [];
  baseinfo;
  institution: LodgeAndCamp;
  link = null;
  subscriptions: Subscription[] = [];
  isAdmin = false;
  isClerk = false;
  isSysAdmin = false;
  isFinancialOfficerCamp = false;
  displayInstitutionChooser = true;
  financeinstitutions: number[] = [];
  memberid: number;

  constructor(
    private fb: FormBuilder,
    private institutionsService: InstitutionsService,
    private router: Router,
    private claimsService: ClaimsService) {
    this.subscriptions.push(this.router.events.pipe().subscribe((event: NavigationStart) => {
      if (event instanceof NavigationStart && event.url === '/medlemsavgifter') {
        this.resetView();
      }
    }));
  }

  ngOnInit() {
    this.institutionform = this.fb.group({
      institutionId: ['', Validators.required]
    });
  
    this.getAllInstitutions(); // new
    this.subscriptions.push(this.claimsService.claims$.subscribe(data => {
      if (data) {
        this.baseinfo = data;
        this.getInstitutions();
      }
    }));

    this.isClerk = this.claimsService.isClerk();
    this.isSysAdmin = this.claimsService.isSysAdmin();
    this.isFinancialOfficerCamp = this.claimsService.isFinancialOfficerCamp();
    this.institutionform.reset();
    this.institutionslist = [];
    this.getInstitutionList();
  }

  ngOnDestroy() {
    this.subscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  getAllInstitutions() {
    this.institutionsService.getInstitutions().subscribe(response => {
      this.institutionlist = response.sort((a, b) => {
        return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
      });
      this.institutionlist.forEach(x => {
        x.name = x.shortName + ' ' + x.name;
      });
      this.institutionlist = this.institutionlist.filter(x => ((x.name)).toLowerCase().indexOf('distrikt') === -1);
    });
  }

  getInstitutionList() {
    this.institutionlist = [];
    this.baseinfo.claimsList.forEach(element => {
      // tslint:disable-next-line:max-line-length
      if (element.key === Enumroles.ADMIN_LODGE || element.key === Enumroles.ADMIN_CAMP || element.key === Enumroles.FINANCIAL_OFFICER_CAMP) {
        const lodgeOrcamp: LodgeAndCamp = {
          id: element.value.id,
          shortName: element.value.shortName,
          name: element.value.name
        };
        this.institutionlist.push(lodgeOrcamp);
      }
    });
  }

  resetView() {
    this.link = null;
    this.ngOnInit();
  }

  getInstitutions() {
    this.subscriptions.push(this.institutionsService.getInstitutions().subscribe(response => {
      if (response) {
        response.forEach(element => {
          const inst = { id: element.id, shortName: element.shortName, name: element.name };
          this.institutionslist.push(inst);
        });

        this.institutionslist = response.sort((a, b) => {
          return SortService.cmpStringsWithNumbers(a.shortName, b.shortName, false);
        });

        if (this.isFinancialOfficerCamp) {
          this.financeinstitutions = [];
          this.financeinstitutions = this.getFinanceInstitutions();
          this.institutionslist = this.institutionslist.filter(element => {
            return this.financeinstitutions.indexOf(element.id) !== -1;
          });
        }
        this.institutionslist.forEach(i => {
          i.name = i.shortName + ' ' + i.name;
        });
        this.institutionslist.unshift({ id: null, shortName: null, name: null });
      }
    }));
  }

  getFinanceInstitutions() {
    this.baseinfo.claimsList.forEach(element => {
      if (element.key === Enumroles.FINANCIAL_OFFICER_CAMP) {
        this.financeinstitutions.push(element.value.id);
      }
    });
    return this.financeinstitutions;
  }

  setInstitution(evt: any) {
    this.isAdmin = this.claimsService.isAdminForInstitution(evt.value.id);
    this.institution = this.institutionslist.find(({ id }) => id === evt.value.id);
  }

  setAction(evt: any) {
    const val = evt.target.value;
    switch (val) {
      case 'searchMeeting': {
        this.searchMeeting();
        break;
      }
      case 'viewInstitution': {
        this.router.navigate(['/institutions/id/', this.institution.id]);
        break;
      }
      case 'addMeeting': {
        this.addMeeting();
        break;
      }
      case 'nedsattning': {
        break;
      }
    }
  }

  searchMeeting() {
    this.link = 'searchMeeting';
  }

  closeSearchMeeting(evt) {
    this.link = null;
  }

  addMeeting() {
    this.link = 'addMeeting';
  }

  closeAddMeeting(evt) {
    this.link = null;
  }
}
